(function () {
    'use strict';

    angular
        .module('app')
        .directive('externalSearch', externalSearch);

    externalSearch.$inject = ['$window', 'pageSearchService'];

    function externalSearch($window, pageSearchService) {
        var directive = {
            bindToController: true,
            controller: ['$scope', '$location', controller],
            controllerAs: '$externalSearch',
            restrict: 'EA',
            link: link
        };

        return directive;

        function link($scope) {
			$("#searchBox").autocomplete({
				highlight: true,
                source: function (request, response) {
                    $.ajax({
                        url: "/api/emr/externalSearch/autocomplete",
                        dataType: "json",
                        type: 'Get',
                        data: {
                            term: request.term,
                            size: window.searchAutocompSize
                        },
                        success: function (data) {
                            response($.map(data.Data,
                                function (item) {
                                    return {
                                        label: item,
                                        value: item
                                    };
                                }));
                        }
                    });
				},
                select: function (event, ui) {
	                $(this).val(ui.item.value);
	                $(this).trigger('input'); // Use for Chrome/Firefox/Edge
	                $(this).trigger('change');
	                $(this).closest('form').submit();
                },
                minLength: 2
            });
        }

        function controller($scope, $location) {
            var $ctrl = this;

            $ctrl.text = "";
            $ctrl.sort = "relevance";
            $ctrl.page = 1;
            $ctrl.pages = [];
            $ctrl.pageSize = 10;
            $ctrl.maxPages = 5;
            $ctrl.results = [];
            $ctrl.shownResults = [];
            $ctrl.totalResults = 0;
            $ctrl.loadingImage = $('#loading');
            $ctrl.timer = null;

            var searchParams = $location.search();

            $ctrl.search = function (e, pageSize, maxPages) {
                if (e) {
                    e.preventDefault();
                }

                $('#searchResults').hide();

                setLoadingSpinner();

                $(".ui-menu-item").hide();

                $ctrl.results = [];
                $ctrl.totalResults = 0;
                $ctrl.pageSize = pageSize;
                $ctrl.maxPages = maxPages;

                pageSearchService.getExternalResults($ctrl.text)
                    .then(function (results) {
                            results.Results.forEach(function (result) {
                                $ctrl.results.push(result);
                            });

                            $ctrl.shownResults = $ctrl.results.slice(0, pageSize);

                            $ctrl.totalResults = results.TotalResults;

                            var pageCount = 1;

                            if ($ctrl.totalResults > pageSize) {
                                pageCount = Math.ceil($ctrl.totalResults / pageSize);
                            }
                            var pages = [];

                            for (var index = 1; index <= pageCount; index++) {
                                pages.push(index);
                            }

                            $ctrl.pages = pages;
                        },
                        function () {
                            console.log('an error occured getting results');
                    });

                clearTimeout($ctrl.timer);
                $ctrl.loadingImage.hide();
                $('#searchResults').show();
            }

            if (searchParams.queryString) {
                $ctrl.text = searchParams.queryString.replace(/&#39;/g, "\'").replace(/&quot;/g, "\"").replace(/&amp;/g, "&");
            }

            $ctrl.clearText = function () {
                $ctrl.text = "";
            }

            $ctrl.sortByRelevance = function () {
                var skip = ($ctrl.page - 1) * $ctrl.pageSize;

                if ($ctrl.sort === "relevance") {
                    $ctrl.sort = "relevanceRev";

                    $ctrl.results.sort(byReverseRelevance);
                } else {
                    $ctrl.sort = "relevance";

                    $ctrl.results.sort(byRelevance);
                }

                $ctrl.shownResults = $ctrl.results.slice(skip, skip + $ctrl.pageSize);
            }

            $ctrl.sortByDate = function () {
                var skip = ($ctrl.page - 1) * $ctrl.pageSize;

                if ($ctrl.sort === "date") {
                    $ctrl.sort = "dateRev";

                    $ctrl.results.sort(byDateAsc);
                } else {
                    $ctrl.sort = "date";

                    $ctrl.results.sort(byDateDesc);
                }

                $ctrl.shownResults = $ctrl.results.slice(skip, skip + $ctrl.pageSize);
            }

            function byDateDesc(a, b) {
                if (a.Date > b.Date) {
                    return -1;
                }
                if (a.Date < b.Date) {
                    return 1;
                }
                return 0;
            }

            function byDateAsc(a, b) {
                if (a.Date < b.Date) {
                    return -1;
                }
                if (a.Date > b.Date) {
                    return 1;
                }
                return 0;
            }

            function byRelevance(a, b) {
                if (a.Relevance > b.Relevance) {
                    return 1;
                }
                if (a.Relevance < b.Relevance) {
                    return -1;
                }

                return 0;
            }

            function byReverseRelevance(a, b) {
                if (a.Relevance < b.Relevance) {
                    return 1;
                }
                if (a.Relevance > b.Relevance) {
                    return -1;
                }

                return 0;
            }

            function setLoadingSpinner() {
                $ctrl.timer && clearTimeout($ctrl.timer);

                $ctrl.timer = setTimeout(function () {
                    $ctrl.loadingImage.show();
                }, 1000);
            }
        }
    }

})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_externalSearch.js
// module id = 16
// module chunks = 0